import { useEffect, useState } from "react";
import setThemeColor from "../../utils/setThemeColor/setThemeColor";
import { Grid } from "../../components/feature/Grid/Grid";
import { NavMenu } from "../../components/feature/NavMenu/NavMenu";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { IOptions } from "../../components/feature/NavMenu/elements/AdditionalOptionsMenu/AdditionalOptionsMenu";
import { useTranslation } from "react-i18next";
import { Nav } from "react-bootstrap";
import { IFilters } from "../../components/feature/Search/elements/FiltersMenu/FiltersMenu";
import Search from "../../components/feature/Search/Search";
import setWebPageTitle from "../../utils/setWebPageTitle/setWebPageTitle";
import setWebPagePreviewImage from "../../utils/setWebPagePreviewImage/setWebPagePreviewImage";

const MyRecipesPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const searchEndpoint = "mypageofrecipes/search";
    const isLoggedIn: boolean = useSelector((state: RootState) => state.client.isLoggedIn);
    const [activeKey, setActiveKey] = useState("public");
    const [isSearchActive, setIsSearchActive] = useState(false);
    const [endpoint, setEndpoint] = useState("mypageofrecipes/" + activeKey);
    const [filters, setFilters] = useState<IFilters>({
        minPublicationDateTime: null,
        maxPublicationDateTime: null,
        minPreparationTime: null,
        maxPreparationTime: null,
        isPublic: null,
        isFromExplore: null,
        languageId: null,
        tags: null,
        searchQuery: null,
    });
    const [options] = useState<IOptions[]>([
        {
            link: "/explore",
            name: t("containers.explorePage.title"),
            icon: <i className="bi bi-globe-americas"></i>,
        },
        {
            link: "/add",
            name: t("containers.addRecipePage.title"),
            icon: <i className="bi bi-plus-circle"></i>,
        },
        {
            link: "/settings",
            name: t("containers.settingsPage.title"),
            icon: <i className="bi bi-gear"></i>,
        },
        {
            link: "/info",
            name: t("containers.infoPage.title"),
            icon: <i className="bi bi-info-circle"></i>,
        },
    ]);

    const handleSelect = (selectedKey: any) => {
        setActiveKey(selectedKey);
    };

    const triggerAction = (action: string) => {
        if (action === "SEARCH") {
            setIsSearchActive(!isSearchActive);
        }
    };

    const onFiltersSelected = (filters: IFilters) => {
        setFilters(filters);
    };

    useEffect(() => {
        if (isSearchActive) {
            setEndpoint(searchEndpoint);
        } else {
            setEndpoint("mypageofrecipes/" + activeKey);
        }
    }, [isSearchActive]);

    useEffect(() => {
        setEndpoint("mypageofrecipes/" + activeKey);
    }, [activeKey]);

    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/explore");
        }
        setThemeColor("#ffffff");
        setWebPageTitle();
        setWebPagePreviewImage();
    }, []);

    return (
        <div>
            <NavMenu
                options={options}
                isSearchActive={true}
                triggerAction={triggerAction}
                title={
                    <span>
                        <i className="bi bi-collection"></i> {t("containers.myRecipesPage.title")}
                    </span>
                }
            />
            {!isSearchActive && (
                <div className="d-flex justify-content-center pt-2">
                    <Nav variant="underline" activeKey={activeKey} onSelect={handleSelect}>
                        <Nav.Item>
                            <Nav.Link eventKey="public" className="text-dark">
                                <h4>
                                    <i className="bi bi-collection"></i>
                                </h4>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="private" className="text-dark">
                                <h4>
                                    <i className="bi bi-lock-fill"></i>
                                </h4>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="explored" className="text-dark">
                                <h4>
                                    <i className="bi bi-globe-americas"></i>
                                </h4>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            )}
            {isSearchActive && <Search selectedFilters={onFiltersSelected} isExploreMode={false} />}
            {endpoint !== searchEndpoint && <Grid endpoint={endpoint} />}
            {endpoint === searchEndpoint && <Grid endpoint={endpoint} filters={filters} />}
        </div>
    );
};

export default MyRecipesPage;
